import { mdiSortAlphabeticalAscending } from '@mdi/js';
import Icon from '@mdi/react';
import { Box, Button, FormControl, FormControlLabel, FormLabel, InputLabel, MenuItem, Popover, Radio, RadioGroup, Select, Typography } from '@mui/material';
import { MouseEvent, useState } from 'react';

import { useFilters } from './FiltersContext';

export const ProfileSort = () => {
  const {
    state: { pagination },
    updatePagination,
  } = useFilters();
  const [sortPopoverAnchorEl, setSortPopoverAnchorEl] = useState<HTMLButtonElement | null>(null);
  const isSortPopoverOpen = Boolean(sortPopoverAnchorEl);
  const sortPopoverId = isSortPopoverOpen ? 'sort-popover' : undefined;

  return (
    <>
      <Button
        endIcon={<Icon path={mdiSortAlphabeticalAscending} size={1} />}
        color={isSortPopoverOpen ? 'inherit' : 'secondary'}
        variant={isSortPopoverOpen ? 'contained' : 'outlined'}
        sx={{
          color: isSortPopoverOpen ? 'primary.dark' : 'secondary',
          backgroundColor: isSortPopoverOpen ? 'primary.light' : 'secondary',
          '&:hover': {
            backgroundColor: isSortPopoverOpen ? 'primary.light' : 'inherit',
          },
          mr: 1,
        }}
        aria-describedby={sortPopoverId}
        onClick={(event: MouseEvent<HTMLButtonElement>) => setSortPopoverAnchorEl(event.currentTarget)}
      >
        Sort
      </Button>
      <Popover
        id={sortPopoverId}
        open={isSortPopoverOpen}
        anchorEl={sortPopoverAnchorEl}
        onClose={() => setSortPopoverAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Box p={2} width="352px">
          <Typography variant="h6" fontWeight="600">
            Sorting settings
          </Typography>
          <FormControl sx={{ my: 3 }} fullWidth>
            <InputLabel id="sort-by-field-label">Sort by</InputLabel>
            <Select
              size="small"
              labelId="sort-by-field-label"
              value={pagination.order}
              label="Sort by"
              onChange={(event) => updatePagination({ ...pagination, order: event.target.value })}
            >
              <MenuItem value={'name'}>School name</MenuItem>
              <MenuItem value={'updatedAt'}>Last updated</MenuItem>
            </Select>
          </FormControl>
          <FormControl>
            <FormLabel id="sort-order-group-label">Order</FormLabel>
            <RadioGroup
              row
              aria-labelledby="sort-order-group-label"
              defaultValue="ASC"
              name="sort-order-group"
              value={pagination.orderDirection}
              onChange={(event) => updatePagination({ ...pagination, orderDirection: event.target.value as 'ASC' | 'DESC' })}
            >
              <FormControlLabel value="ASC" control={<Radio />} label="Ascending" />
              <FormControlLabel value="DESC" control={<Radio />} label="Descending" />
            </RadioGroup>
          </FormControl>
        </Box>
      </Popover>
    </>
  );
};
